import React, { useState } from "react";
import Select from "react-select";
import { dialog } from "nq-component";

const adjustmentOptions = [
  { value: "Beginning Inventory", label: "Beginning Inventory" },
  { value: "Manual Add", label: "Manual Add" },
  { value: "Manual Deduct", label: "Manual Deduct" },
  { value: "Actual Count", label: "Actual Count" },
];

const AdjustmentTypeModal = ({ onContinue }) => {
  const [selectedType, setSelectedType] = useState(null);

  const handleContinue = () => {
    if (!selectedType) {
      alert("Please select an adjustment type.");
      return;
    }
    dialog.close();
    onContinue(selectedType.value);
  };

  return (
    <div>
      <h6 className="m-3">Adjustment Type</h6>
      <hr className="ms-4" style={{ width: "450px" }} />
      <p className="m-3">
        Select your preferred Adjustment type below to continue.
      </p>

      <div className="m-3">
        <Select
          options={adjustmentOptions}
          placeholder="Select Adjustment Type"
          value={selectedType}
          onChange={setSelectedType}
        />
      </div>

      <div className="d-flex justify-content-center mt-4 mb-3">
        <button
          className="btn me-2"
          onClick={() => dialog.close()}
          style={{ backgroundColor: "#d1d1d1" }}
        >
          Cancel
        </button>
        <button className="btn btn-success text-white" onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default AdjustmentTypeModal;
